<template>
  <div class="coming-soon">
    <div class="modal coming-soon-modal">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-content">
        <!-- <div class="modal-card"> -->
        <section class="modal-card-body">{{msg}}</section>
        <!-- </div> -->
        <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComingSoon",
  props: {
    msg: String
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    }
  }
};
</script>

<style scoped>
.modal-card-body {
  width: 95vw;
  margin: 0 auto;
}
</style>